<template>
    <v-autocomplete
      v-model="stockages"
      :items="$store.state.stockages.all"
      item-title="name"
      item-value="pk"
      :label="$filters.capitalize($t('stockages.label', 1))"
      :multiple="multiple"
      :filter="filterStockages"
      @update:modelValue="updateStockage"
      :clearable="true"
      variant="solo"
      class="mr-3"
      density= 'compact'
      hide-details
      return-object
    >
    {{console.log(stockages)}}
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            {{
              $filters.capitalize(
                $t("search_for", { noun: $t("stockages.label", 1) })
              )
            }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-autocomplete>
</template>
<script>
import filters from "@/mixins/filters";
import { isNone } from "@/functions";

export default {
  mixins: [filters],

  props: {
    multiple: {type:Boolean, default:false, require:false}
  },
  methods: {
    updateStockage(item) {
      this.$emit("updateStockage", item);
    },
  },
  created(){
    const temp = this.$store.getters.dataEdit('stockages');
    this.producers = temp.pk ? { ...temp } : null;
  },
  data() {
    return {
      stockages:null,
    };
  },
};
</script>
